import PitchCall from './PitchCall.js';
import PitchResult from './PitchResult.js';
import PlateAppearanceResult from './PlateAppearanceResult.js';

/**
 * Describes possible combination of plays and how do they link together between old and new scoring
 * pitchResult describes option from PitchResult enum (BBH scoring), null when not supported in BBH
 * pitchCall describes option from PitchCall enum (new scoring), null if there is no single value that can be used
 * plateAppearanceResult describes option from PlateAppearanceResult enum (new scoring), null if there is no single value that can be used
 * @see https://flightscope.atlassian.net/browse/BBP-691?focusedCommentId=45443
 */
const PitchResultCombined = {
    // BaseHits
    Single: {
        key: `${PitchCall.BallInPlay.key}-${PlateAppearanceResult.Single.key}`,
        name: PlateAppearanceResult.Single.name,
        pitchResult: PitchResult.Single.key,
        pitchCall: PitchCall.BallInPlay.key,
        plateAppearanceResult: PlateAppearanceResult.Single.key
    },
    Double: {
        key: `${PitchCall.BallInPlay.key}-${PlateAppearanceResult.Double.key}`,
        name: PlateAppearanceResult.Double.name,
        pitchResult: PitchResult.Double.key,
        pitchCall: PitchCall.BallInPlay.key,
        plateAppearanceResult: PlateAppearanceResult.Double.key
    },
    Triple: {
        key: `${PitchCall.BallInPlay.key}-${PlateAppearanceResult.Triple.key}`,
        name: PlateAppearanceResult.Triple.name,
        pitchResult: PitchResult.Triple.key,
        pitchCall: PitchCall.BallInPlay.key,
        plateAppearanceResult: PlateAppearanceResult.Triple.key
    },
    HomeRun: {
        key: `${PitchCall.BallInPlay.key}-${PlateAppearanceResult.HomeRun.key}`,
        name: PlateAppearanceResult.HomeRun.name,
        pitchResult: PitchResult.HomeRun.key,
        pitchCall: PitchCall.BallInPlay.key,
        plateAppearanceResult: PlateAppearanceResult.HomeRun.key
    },
    InsideTheParkHomeRun: {
        key: `${PitchCall.BallInPlay.key}-${PlateAppearanceResult.InsideTheParkHomeRun.key}`,
        name: PlateAppearanceResult.InsideTheParkHomeRun.name,
        pitchResult: null, // not available in old sessions
        pitchCall: PitchCall.BallInPlay.key,
        plateAppearanceResult: PlateAppearanceResult.InsideTheParkHomeRun.key
    },
    GroundRuleDouble: {
        key: `${PitchCall.BallInPlay.key}-${PlateAppearanceResult.GroundRuleDouble.key}`,
        name: PlateAppearanceResult.GroundRuleDouble.name,
        pitchResult: null, // not available in old sessions
        pitchCall: PitchCall.BallInPlay.key,
        plateAppearanceResult: PlateAppearanceResult.GroundRuleDouble.key
    },

//BatterSafe: { key: 'BatterSafe', name: 'Batter safe', results: [
    Walk: {
        key: `${PitchCall.Ball.key}-${PlateAppearanceResult.Walk.key}`,
        name: PlateAppearanceResult.Walk.name,
        pitchResult: PitchResult.Walk.key,
        pitchCall: PitchCall.Ball.key,
        plateAppearanceResult: PlateAppearanceResult.Walk.key
    },
    IntentionalWalk: {
        key: `${PitchCall.NoPitch.key}-${PlateAppearanceResult.IntentionalWalk.key}`,
        name: PlateAppearanceResult.IntentionalWalk.name,
        pitchResult: null, // not available in old sessions
        pitchCall: PitchCall.NoPitch.key,
        plateAppearanceResult: PlateAppearanceResult.IntentionalWalk.key
    },
    HitByPitch: {
        key: `${PitchCall.HitByPitch.key}-${PlateAppearanceResult.HitByPitch.key}`,
        name: PlateAppearanceResult.HitByPitch.name,
        pitchResult: PitchResult.HitByPitch.key,
        pitchCall: PitchCall.HitByPitch.key,
        plateAppearanceResult: PlateAppearanceResult.HitByPitch.key
    },
    ReachedOnError: {
        key: `${PitchCall.BallInPlay.key}-${PlateAppearanceResult.ReachedOnError.key}`,
        name: PlateAppearanceResult.ReachedOnError.name,
        pitchResult: PitchResult.Error.key,
        pitchCall: PitchCall.BallInPlay.key,
        plateAppearanceResult: PlateAppearanceResult.ReachedOnError.key
    },
    FieldersChoice: {
        key: `${PitchCall.BallInPlay.key}-${PlateAppearanceResult.FieldersChoice.key}`,
        name: PlateAppearanceResult.FieldersChoice.name,
        pitchResult: null, // not available in old sessions
        pitchCall: PitchCall.BallInPlay.key,
        plateAppearanceResult: PlateAppearanceResult.FieldersChoice.key
    },
    CatcherInterference: {
        key: `*-${PlateAppearanceResult.CatcherInterference.key}`,
        name: PlateAppearanceResult.CatcherInterference.name,
        pitchResult: null, // not available in old sessions
        pitchCall: null, // TODO - not sure if it's always this case
        plateAppearanceResult: PlateAppearanceResult.CatcherInterference.key
    },
    WildPitch: {
        key: `*-${PlateAppearanceResult.WildPitch.key}`,
        name: PlateAppearanceResult.WildPitch.name,
        pitchResult: null, // not available in old sessions
        pitchCall: null,
        plateAppearanceResult: PlateAppearanceResult.WildPitch.key
    },
    PassedBall: {
        key: `*-${PlateAppearanceResult.PassedBall.key}`,
        name: PlateAppearanceResult.PassedBall.name,
        pitchResult: null, // not available in old sessions
        pitchCall: null,
        plateAppearanceResult: PlateAppearanceResult.PassedBall.key
    },
    SacrificeOnError: {
        key: `${PitchCall.BallInPlay.key}-${PlateAppearanceResult.SacrificeOnError.key}`,
        name: PlateAppearanceResult.SacrificeOnError.name,
        pitchResult: null, // not available in old sessions
        pitchCall: PitchCall.BallInPlay.key,
        plateAppearanceResult: PlateAppearanceResult.SacrificeOnError.key
    },
    SacrificeOnFieldersChoice: {
        key: `${PitchCall.BallInPlay.key}-${PlateAppearanceResult.SacrificeOnFieldersChoice.key}`,
        name: PlateAppearanceResult.SacrificeOnFieldersChoice.name,
        pitchResult: null, // not available in old sessions
        pitchCall: PitchCall.BallInPlay.key,
        plateAppearanceResult: PlateAppearanceResult.SacrificeOnFieldersChoice.key
    },

// BatterOut: { key: 'BatterOut', name: 'Batter out', results: [
    FieldOut: {
        key: `${PitchCall.BallInPlay.key}-${PlateAppearanceResult.FieldOut.key}`,
        name: PitchResult.ContactOut.name,
        pitchResult: PitchResult.ContactOut.key,
        pitchCall: PitchCall.BallInPlay.key,
        plateAppearanceResult: PlateAppearanceResult.FieldOut.key
    },
    SwingingStrikeout: {
        key: `${PitchCall.SwingingStrike.key}-${PlateAppearanceResult.SwingingStrikeout.key}`,
        name: PlateAppearanceResult.SwingingStrikeout.name,
        pitchResult: PitchResult.StrikeoutSwinging.key,
        pitchCall: PitchCall.SwingingStrike.key,
        plateAppearanceResult: PlateAppearanceResult.SwingingStrikeout.key
    },
    CalledStrikeout: {
        key: `${PitchCall.CalledStrike.key}-${PlateAppearanceResult.CalledStrikeout.key}`,
        name: PlateAppearanceResult.CalledStrikeout.name,
        pitchResult: PitchResult.StrikeoutLooking.key,
        pitchCall: PitchCall.CalledStrike.key,
        plateAppearanceResult: PlateAppearanceResult.CalledStrikeout.key
    },
    SacrificeFly: {
        key: `${PitchCall.BallInPlay.key}-${PlateAppearanceResult.SacrificeFly.key}`,
        name: PlateAppearanceResult.SacrificeFly.name,
        pitchResult: null, // not available in old sessions
        pitchCall: PitchCall.BallInPlay.key,
        plateAppearanceResult: PlateAppearanceResult.SacrificeFly.key
    },
    SacrificeBunt: {
        key: `${PitchCall.BallInPlay.key}-${PlateAppearanceResult.SacrificeBunt.key}`,
        name: PlateAppearanceResult.SacrificeBunt.name,
        pitchResult: null, // not available in old sessions
        pitchCall: PitchCall.BallInPlay.key,
        plateAppearanceResult: PlateAppearanceResult.SacrificeBunt.key
    },
    SacrificePlay: {
        key: `${PitchCall.BallInPlay.key}-${PlateAppearanceResult.SacrificePlay.key}`,
        name: PlateAppearanceResult.SacrificePlay.name,
        pitchResult: null, // not available in old sessions
        pitchCall: PitchCall.BallInPlay.key,
        plateAppearanceResult: PlateAppearanceResult.SacrificePlay.key
    },
    InfieldFly: {
        key: `${PitchCall.BallInPlay.key}-${PlateAppearanceResult.InfieldFly.key}`,
        name: PlateAppearanceResult.InfieldFly.name,
        pitchResult: null, // not available in old sessions
        pitchCall: PitchCall.BallInPlay.key,
        plateAppearanceResult: PlateAppearanceResult.InfieldFly.key
    },
    BatterInterference: {
        key: `*-${PlateAppearanceResult.BatterInterference.key}`,
        name: PlateAppearanceResult.BatterInterference.name,
        pitchResult: null, // not available in old sessions
        pitchCall: null, // any pitch call
        plateAppearanceResult: PlateAppearanceResult.BatterInterference.key
    },
    FoulTipOut: {
        key: `${PitchCall.FoulTip.key}-${PlateAppearanceResult.FoulTipOut.key}`,
        name: PlateAppearanceResult.FoulTipOut.name,
        pitchResult: null, // not available in old sessions
        pitchCall: PitchCall.FoulTip.key,
        plateAppearanceResult: PlateAppearanceResult.FoulTipOut.key
    },
    FoulOut: {
        key: `${PitchCall.FoulTip.key}-${PlateAppearanceResult.FoulOut.key}`,
        name: PlateAppearanceResult.FoulOut.name,
        pitchResult: null, // not available in old sessions
        pitchCall: PitchCall.FoulTip.key, // TODO - we could have a different definition here as US guys recommend to remove foul outs...
        plateAppearanceResult: PlateAppearanceResult.FoulOut.key
    },
    BatterOut: {
        key: `*-${PlateAppearanceResult.BatterOut.key}`,
        name: PlateAppearanceResult.BatterOut.name,
        pitchResult: null, // not available in old sessions
        pitchCall: null, // any pitch call
        plateAppearanceResult: PlateAppearanceResult.BatterOut.key
    },

// NoResult: { key: 'NoResult', name: 'No result', results: [
    Ball: {
        key: `${PitchCall.Ball.key}-${PlateAppearanceResult.NotAvailable.key}`,
        name: PitchCall.Ball.name,
        pitchResult: PitchResult.Ball.key,
        pitchCall: PitchCall.Ball.key,
        plateAppearanceResult: PlateAppearanceResult.NotAvailable.key
    },
    IntentionalBall: {
        key: `${PitchCall.IntentionalBall.key}-${PlateAppearanceResult.NotAvailable.key}`,
        name: PitchCall.IntentionalBall.name,
        pitchResult: PitchResult.IntentionalBall.key,
        pitchCall: PitchCall.IntentionalBall.key,
        plateAppearanceResult: PlateAppearanceResult.NotAvailable.key
    },
    SwingingStrike: {
        key: `${PitchCall.SwingingStrike.key}-${PlateAppearanceResult.NotAvailable.key}`,
        name: PitchCall.SwingingStrike.name,
        pitchResult: PitchResult.SwingingStrike.key,
        pitchCall: PitchCall.SwingingStrike.key,
        plateAppearanceResult: PlateAppearanceResult.NotAvailable.key
    },
    CalledStrike: {
        key: `${PitchCall.CalledStrike.key}-${PlateAppearanceResult.NotAvailable.key}`,
        name: PitchCall.CalledStrike.name,
        pitchResult: PitchResult.CalledStrike.key,
        pitchCall: PitchCall.CalledStrike.key,
        plateAppearanceResult: PlateAppearanceResult.NotAvailable.key
    },
    FoulBall: {
        key: `${PitchCall.FoulBall.key}-${PlateAppearanceResult.NotAvailable.key}`,
        name: PitchCall.FoulBall.name,
        pitchResult: PitchResult.FoulBall.key,
        pitchCall: PitchCall.FoulBall.key,
        plateAppearanceResult: PlateAppearanceResult.NotAvailable.key
    },
    FoulBunt: {
        key: `${PitchCall.FoulBunt.key}-${PlateAppearanceResult.NotAvailable.key}`,
        name: PitchCall.FoulBunt.name,
        pitchResult: null, // not available in the old version
        pitchCall: PitchCall.FoulBunt.key,
        plateAppearanceResult: PlateAppearanceResult.NotAvailable.key
    },
    IllegalPitch: {
        key: `${PitchCall.IllegalPitch.key}-${PlateAppearanceResult.NotAvailable.key}`,
        name: PitchCall.IllegalPitch.name,
        pitchResult: null, // not available in old sessions
        pitchCall: PitchCall.IllegalPitch.key,
        plateAppearanceResult: PlateAppearanceResult.NotAvailable.key
    },
    Balk: {
        key: `${PitchCall.Balk.key}-${PlateAppearanceResult.NotAvailable.key}`,
        name: PitchCall.Balk.name,
        pitchResult: null, // not available in old sessions
        pitchCall: PitchCall.Balk.key,
        plateAppearanceResult: PlateAppearanceResult.NotAvailable.key
    },
    PitchOut: {
        key: `${PitchCall.PitchOut.key}-${PlateAppearanceResult.NotAvailable.key}`,
        name: PitchCall.PitchOut.name,
        pitchResult: null, // not available in old sessions
        pitchCall: PitchCall.PitchOut.key,
        plateAppearanceResult: PlateAppearanceResult.NotAvailable.key
    },
    NoPitch: {
        key: `${PitchCall.NoPitch.key}-${PlateAppearanceResult.NotAvailable.key}`,
        name: PitchCall.NoPitch.name,
        pitchResult: null, // not available in old sessions
        pitchCall: PitchCall.NoPitch.key,
        plateAppearanceResult: PlateAppearanceResult.NotAvailable.key
    },
    Unidentified: {
        key: `${PitchCall.Unidentified.key}-${PlateAppearanceResult.Unidentified.key}`,
        name: PitchCall.Unidentified.name,
        pitchResult: PitchResult.Unidentified.key,
        pitchCall: PitchCall.Unidentified.key,
        plateAppearanceResult: PlateAppearanceResult.Unidentified.key
    },

    /**
     * Allows to match deprecated pitch result enum value to combined group
     * @param {String} pitchResult - key from PitchResult enum
     * @returns {(Object|null)} NULL or object containing key, name, pitchResult, pitchCall and plateAppearanceResult
     */
    matchToOldScoring(pitchResult) {
        for (const key in this) {
            if (!Object.hasOwnProperty.call(this, key)) {
                continue;
            }

            const combined = this[key];
            if (combined && combined.pitchResult === pitchResult) {
                return combined;
            }
        }

        return null;
    },

    /**
     * Allows to match new scoring values to combined group
     * @param {String} paResult - key from PlateAppearanceResult enum
     * @param {String} pitchCall - key from PitchCall enum
     * @returns {(Object|null)} NULL or object containing key, name, pitchResult, pitchCall and plateAppearanceResult
     */
    matchToNewScoring(paResult, pitchCall) {
        for (const key in this) {
            if (!Object.hasOwnProperty.call(this, key)) {
                continue;
            }

            const combined = this[key];
            if (
                combined
                && (
                    combined.pitchCall === pitchCall
                    || combined.pitchCall === null
                )
                && combined.plateAppearanceResult === paResult
            ) {
                return combined;
            }
        }

        return null;
    },
};

export default PitchResultCombined;